<template>
    <v-snackbar
      v-model="show"
      :timeout="timeout"
      :color="toastColor"
      bottom
      shaped
      right
    >
      {{ message }}
    </v-snackbar>
  </template>
  
  <script>
  export default {
    props: {
      message: String,
      type: {
        type: String,
        default: "success",
      },
      timeout: {
        type: Number,
        default: 5000,
      },
    },
    data() {
      return {
        show: true, // 這裡保留 show，因為它控制顯示/隱藏
      };
    },
    computed: {
        toastColor() {
    return {
      success: "#4CAF50",  // 綠色
      error: "#F44336",    // 紅色
      warning: "#FF9800",  // 橘色
      info: "#2196F3",     // 藍色
    }[this.type] || "#607D8B"; // 預設藍灰色
  },
  },
  };
  </script>
  
<style scoped>
  .v-snackbar {
    font-size: 14px;
  }
</style>
  